export enum ConversationMessageSenderType {
  Status = 0,
  Self = 1,
  Other = 2,
}